import { faLink } from "@fortawesome/pro-regular-svg-icons";

import { Flow } from "src/api/flowTypes";
import { Pill } from "src/base-components/Pill";
import { pluralize } from "src/utils/stringUtils";

type Props = {
  parentFlows: Flow["parent_flows"];
  childFlows: Flow["child_flows"];
};

export const LinkedFlowsPill: React.FC<Props> = ({
  parentFlows,
  childFlows,
}) => {
  const getAdditionalLinksExtension = (linkedFlowsCount: number) => {
    if (linkedFlowsCount < 2) {
      return "";
    }
    return ` + ${pluralize(linkedFlowsCount - 1, "other Decision Flow")}`;
  };

  const getPillText = () => {
    if (parentFlows && parentFlows.length > 0) {
      return `Called by ${parentFlows[0].name}${getAdditionalLinksExtension(parentFlows.length)}`;
    }
    if (childFlows && childFlows.length > 0) {
      return `Calling ${childFlows[0].name}${getAdditionalLinksExtension(childFlows.length)}`;
    }
    return undefined;
  };

  const pillText = getPillText();

  return (
    pillText && (
      <Pill size="sm" variant="outlined-white">
        <div className="flex flex-row items-center pl-0.5">
          <Pill.Icon icon={faLink} padding={false} />
          <Pill.Text>{pillText}</Pill.Text>
        </div>
      </Pill>
    )
  );
};
